export const Include_bins = (source_group, key_to_remove) => {
  return {
    all: function () {
      return source_group.all().filter(function (d) {
        //return Math.abs(d.value) > 0.00001; // if using floating-point numbers
        return d.key == key_to_remove; // if integers only
      });
    },
  };
};
